import { render } from "./AddEditArtSku.vue?vue&type=template&id=3612f235"
import script from "./AddEditArtSku.vue?vue&type=script&lang=js"
export * from "./AddEditArtSku.vue?vue&type=script&lang=js"

import "./AddEditArtSku.vue?vue&type=style&index=0&id=3612f235&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__